
/**
 * Cleans an Australian phone number with area code and optional country code.
 * @param value A landline or mobile phone number, with area code and optional country code. e.g. "+614 0012 3456"
 * @returns A cleaned string of the phone number, without country code. e.g. "0400123456"
 */
export const cleanPhoneNumber = (value: string) => {
  return value.replaceAll(/[\s-+()]/g, '').replace(/^61/, '0');
}


/**
 * Format an Australian phone number.
 * @param value A landline or mobile phone number, with area code and optional country code. e.g. "+614 0012 3456"
 * @param e164 Indicate whether the number should be formatted to ITU-T Recommendation E.164 specification
 * @returns A string of the number with convential digit groupings. e.g. "0400 123 456" or "(03) 6312 3456", or an E.164 formatted number "+61400123456"
 */
export const formatPhoneNumber = (value: string, e164: boolean = false) => {
  const cleaned = cleanPhoneNumber(value);
  if (e164) {
    const number = cleaned.match(/^0(\d)(\d{4})(\d{4})$/);
    return number ? `+61${number.slice(1).join('')}` : '';
  }

  const mobile = cleaned.match(/^(04\d{2})(\d{3})(\d{3})$/);
  if (mobile) {
    return mobile.slice(1).join(' ');
  }
  
  const landline = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
  if (landline) {
    const [areaCode, part1, part2] = landline.slice(1);
    return `(${areaCode}) ${part1} ${part2}`;
  }

  return value;
}
